/*
SVG Sprite
*/
const files = require.context(__dirname, false, /\.svg$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/site/sprites/index.js